import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";

// i18next kaldırıldı (2 Kasım): site tek dil, çeviri hiç çağrılmıyordu; paket boşuna yükleniyordu.
function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
